// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import InstagramOutlinedSvg from "@ant-design/icons-svg/es/asn/InstagramOutlined";
import AntdIcon from '../components/AntdIcon';

var InstagramOutlined = function InstagramOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: InstagramOutlinedSvg
  }));
};

InstagramOutlined.displayName = 'InstagramOutlined';
export default React.forwardRef(InstagramOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/InstagramOutlined.js
// module id = 1367
// module chunks = 0